
// Archivo generado automáticamente por el pipeline


export const API_URL='https://search.amxinfra.com/api/clarosports/';
export const API_TOKEN='https://api.amxinfra.com/agentcore/token';
export const API_SEARCH_GAME='https://api.amxinfra.com/api/core-clarosports/v2/';
export const PATHURLDOMAIN='https://www.clarosports.com/';
export const API_LOCAL='https://cdn.amxinfra.com/json/buscador/';
export const PAGESIZE=20;
export const MAX_RETRIES = 3; // Número máximo de reintentos
export const LEGAL_PATROCINADOR_CALIENTE='Permiso SEGOB DGG/SP/404/97. Diviértete responsablemente. Los juegos de apuestas están prohibidos para menores de edad.';
export const LEGAL_PATROCINADOR_CODERE='Permiso SEGOB no. 2768. Consulta términos y condiciones en http://codere.mx';
export const MOMIOS='false';
export const PATROCINADOR='CALIENTE';
